import React from "react";
import resumeData from "./resumeData.json";

import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Resume from "./Components/Resume";
import Contact from "./Components/Contact";
import Portfolio from "./Components/Portfolio";

import "./App.css";

const App = () => (
  <div className="App">
    <Header data={resumeData.main} />
    <Resume data={resumeData.resume} />
    <Portfolio />
    <Contact data={resumeData.main} />
    <Footer data={resumeData.main} />
  </div>
);

export default App;
